import * as React from 'react'
import NotFoundPage from 'components/not-found-page'
export default function ShortlinkNotFound(): React.ReactElement {
  return (
    <NotFoundPage
      subtitle="This link doesn't work."
      body={
        <span>
          Please contact the person who sent you this list for another link.
        </span>
      }
    />
  )
}
